import { Col, Row, Select } from 'antd'
import React from 'react'
import PictogramSelector from './PictogramSelector'
import { FormState } from './Aspects'

type Props = {
    aspect: FormState;
    aspectIndex: number;
    handlePictogramChange: (index: number, pictogram: string) => void;
    handleMessageChange: (aspectIndex: number, messageIndex: number, event: React.ChangeEvent<HTMLTextAreaElement>) => void;
    handleTextAlignChange: (aspectIndex: number, value: "center" | "left" | "right") => void;
}

const AspectComp = ({
    aspect,
    aspectIndex,
    handlePictogramChange,
    handleMessageChange,
    handleTextAlignChange
}: Props) => {
    return (
        <Row key={aspectIndex} style={{ marginBottom: "20px" }}>
            <Col span={6}>
                <PictogramSelector aspect={aspect} handlePictogramChange={handlePictogramChange} index={aspectIndex} />
            </Col>
            <Col span={18}>
                {aspect.messages.map((message, messageIndex) => (
                    <div key={messageIndex} style={{ marginBottom: "1px" }}>
                        <textarea
                            id={`messageText-${aspectIndex}-${messageIndex}`}
                            maxLength={18}
                            value={message}
                            onChange={(e) => handleMessageChange(aspectIndex, messageIndex, e)}
                            placeholder={`Escribe el mensaje ${messageIndex + 1}...`}
                            style={{
                                width: "350px",
                                height: "40px",
                                backgroundColor: "#000",
                                color: "#fff",
                                textAlign: "center",
                                fontSize: "20px",
                                textTransform: "uppercase",
                            }}
                        />
                        {/* <p>{message.length}/16 caracteres</p> */}
                    </div>
                ))}
                <Select
                    value={aspect.textAlign}
                    onChange={(value) => handleTextAlignChange(aspectIndex, value)}
                    style={{ width: "350px", marginBottom: "10px" }}
                    disabled
                >
                    <Select.Option value="center">Centrado</Select.Option>
                    <Select.Option value="left">Izquierda</Select.Option>
                    <Select.Option value="right">Derecha</Select.Option>
                </Select>
            </Col>
        </Row>
    )
}

export default AspectComp